import React, { forwardRef, Ref } from 'react'
import cn from 'classnames'
import { IconBase } from 'components/ui/IconBase'

import s from './IconSpinner.module.less'

export interface TIconSpinnerProps extends ISvgIconProps {
  /** Цвет спиннера */
  color?: 'accent' | 'inverted'
  /** Толщина крутящейся линии */
  strokeWidth?: number
}

export const IconSpinner = forwardRef(function IconSpinner(
  { strokeWidth = 4, color = 'accent', ...props }: TIconSpinnerProps,
  ref: Ref<SVGSVGElement>
) {
  return (
    <IconBase {...props} innerRef={ref}>
      <svg className={s.circular} viewBox="25 25 50 50">
        <circle
          className={cn([s.path], s[`path_color_${color}`])}
          cx="50"
          cy="50"
          fill="none"
          r="20"
          strokeMiterlimit={10}
          strokeWidth={strokeWidth}
        />
      </svg>
    </IconBase>
  )
})
